import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Layout from "../../../layouts/Layout";
import Chat from "../../../shared/Chat/Chat";
import { useDispatch, useSelector } from "react-redux";
import { getConversations, getGroups, getGroupsWithConversations } from "../../../services/api";
import { useToast } from "../../../context/ToastContext";
import { useSearchParams } from "react-router-dom";
import { filterOptionsActions } from "../../../store/FiltersOptions";


const AnalystMessages = () => {
    const sessionData = useSelector((state) => state.auth.sessionData);
    const { showToast } = useToast();
    const dispatch = useDispatch();
    const multipartheaders = useMemo(() => {
        return { sessionid: sessionData.sessionId, "Content-Type": "multipart/form-data" };
    }, [sessionData.sessionId]);
    const headers = useMemo(() => {
        return { sessionid: sessionData.sessionId };
    }, [sessionData.sessionId]);
  
    const [groupID, setGroupID] = useState('');
    const [updateCounter, setUpdateCounter] = useState(0);
    const [conversationID, setConversationID] = useState('');
    const [conversations, setConversations] = useState([]);
    const [groupsAndConversations, setGroupsAndConversations] = useState([]);
    const [regulatorsSGB, setRegulatorsSGB] = useState([]);

    const [regulatorsSGBRes, setRegulatorsSGBRes] = useState([]);
    const [initialMessages, setInitialMessages] = useState([]);
    const [ids, setIds] = useState({});
    const hasInitialized = useRef(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const group = searchParams.get('group');
    const getIdsHandler = useCallback((reponseData, groupID, cId) => {
        if (reponseData.length) {
            const singleGroup = reponseData.find(r => r.groupID === groupID);
            const item = singleGroup?.groupID ? singleGroup :reponseData[0];
            let conversationID = '';
            if (item.conversations?.length) {
                const singleConversation = item.conversations[0]
                conversationID = singleConversation.conversationID
                setIds({ conversationID: cId ? cId : conversationID, groupID: item.groupID, groupName: item.groupName, isRead: singleConversation.unreadMessageCount ? true : false })
            }
     
        }
    }, []);

    const getAnalystGroupsHandler = useCallback((type = '') => {
        const getResponse = (response) => {
            if (response.result === "SUCCESS") {
                const reponseData = response?.data ? response?.data : {}
                let groups = reponseData?.otherGroups?.length ? reponseData?.otherGroups : [];
                if(reponseData?.activeGroup){
                    groups = [reponseData.activeGroup, ...groups];
                }
                dispatch(filterOptionsActions.setMessageCount(reponseData?.totalUnreadConversations ?? 0));
                setConversations(groups);
                if(reponseData?.activeGroup && !type && !group && !hasInitialized.current){
                   const activeGroup = reponseData?.activeGroup;
                   const [firstConversation] = activeGroup.conversations || [];
                    if (firstConversation) {
                        setIds({
                            groupID: activeGroup.groupID,
                            groupName: activeGroup.groupName,
                            conversationID: firstConversation.conversationID,
                            isRead: firstConversation.unreadMessageCount ? true : false
                        });
                        setInitialMessages(
                            firstConversation.messages?.length
                                ? [...firstConversation.messages].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                : []
                        );
                        setGroupsAndConversations(groups)
                    } else {
                        setGroupID(reponseData?.activeGroup.groupID);
                    }
                 }
            } else {
                setConversations([]);
            }
        };
        getGroupsWithConversations(multipartheaders, dispatch, getResponse);
    }, [dispatch, group, multipartheaders]);
    useEffect(() => {
        getAnalystGroupsHandler();
    }, [getAnalystGroupsHandler]);
    useEffect(() => {
        const fetchAndSetGroups = (roleId, setter) => {
            getGroups(roleId, headers, dispatch, (response) => {
                if (response.result === "SUCCESS") {
                    const activeGroups = (response.data || []).filter(r => r.status === "active");
                    setRegulatorsSGBRes(activeGroups);
                } else {
                    const error = response.error;
                    showToast(error?.severity, error?.errorMsg || error?.summary);
                }
            });
        };
        // Fetch multiple roles
        fetchAndSetGroups("3,4");
    }, [dispatch, headers, showToast]);
    useEffect(() => {
        if (regulatorsSGBRes.length && conversations.length) {
            const groupIds = conversations.map(s => s.groupID)
            const rolesData = regulatorsSGBRes.filter(r => !groupIds.includes(r.id));
            setRegulatorsSGB(rolesData)
        } else {
            setRegulatorsSGB(regulatorsSGBRes)
        }
    }, [conversations, regulatorsSGBRes])
    const mergeGroupConversations = useCallback((singleGroupConversation, groupID, conversationID, type) => {
        if (conversations?.length && singleGroupConversation?.conversations?.length) {
            let singleGroup = singleGroupConversation;
            let convesationsList = conversations.map(c =>
                c.groupID === groupID
                    ? { ...c, conversations: singleGroup.conversations, unreadConversationCount: singleGroup.totalUnreadConversations }
                    : { ...c, conversations: [] }
            );
            const totalCount = convesationsList.map(c => c.unreadConversationCount).reduce((a, b) => a + b, 0);
            dispatch(filterOptionsActions.setMessageCount(totalCount ?? 0));
            setGroupsAndConversations(convesationsList);
            if (!type) {
                getIdsHandler(convesationsList, groupID, conversationID);
                if (!conversationID) {
                    const { messages = [] } = singleGroup.conversations[0] || {};
                    const sortedMessages = [...messages].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                    setInitialMessages(sortedMessages);
                }
            }
        } else {
            setGroupsAndConversations(conversations)
        }
    }, [conversations, dispatch, getIdsHandler]);

    const getConversationHandler = useCallback((groupID, conversationID, type = '') => {
        const getResponse = (response) => {
            if (response.result === "SUCCESS") {
                const responseData = response.data ? response.data : {};
                mergeGroupConversations(responseData, groupID, conversationID, type);
            }
        };
        getConversations(groupID, headers, dispatch, getResponse)
    }, [dispatch, headers, mergeGroupConversations]);

    useEffect(() => {
        if (groupID && conversations.length) {
            getConversationHandler(groupID, conversationID)
        }
    }, [conversationID, conversations, getConversationHandler, groupID, updateCounter]);
    useEffect(() => {
        const group = searchParams.get('group');
        const conversation = searchParams.get('conversation');

        if (!hasInitialized.current && group && conversation) {
            setGroupID(+group);
            setConversationID(+conversation);
            const newParams = new URLSearchParams(searchParams.toString());
            newParams.delete('group');
            newParams.delete('conversation');
            setSearchParams(newParams);

            hasInitialized.current = true;
        }
    }, [searchParams, setSearchParams]);

    const refetchHandler = (data, type) => {
        if(type === 'create'){
           setIds(data);
           setConversations([]);
           setGroupID(data.groupID);
           setConversationID(data.conversationID);
           getAnalystGroupsHandler(type);
         } else {
           setIds(data)
           setGroupID(data.groupID);
           setConversationID(data.conversationID);
           getConversationHandler(data.groupID, data.conversationID,  type);
           if(type === 'read'){
             getAnalystGroupsHandler(type);
           }
         }
    }
    const getGroupIDHandler = (value) => {
        setIds({})
        setConversationID('')
        setGroupID(value)
        setUpdateCounter(prev => prev + 1); 
    }
    const fromAuditLog = searchParams.get("from") === "audit-log";
    return (<>
        <Layout backBtn={fromAuditLog ? "audit-log" : "home"} backBtnLabel={fromAuditLog ? "Audit Log" : "Home"}>
            <Chat type={'analyst'} conversations={groupsAndConversations} regulatorsSGB={regulatorsSGB} refetchHandler={refetchHandler}  getGroupIDHandler={getGroupIDHandler} ids={ids} initialMessages={initialMessages} ></Chat>
        </Layout>

    </>)

}

export default AnalystMessages;